import React from 'react';
import PropTypes from 'prop-types';

/**
 * 파트너 쿠폰 판매가
 */
function PartnerBurdenNum({ isSkim, price }) {
  return (
    <span className="partner_burden_num">
      {isSkim ? TMON.util.numberWithString(price) : price}
    </span>
  );
}

PartnerBurdenNum.propTypes = {
  isSkim: PropTypes.bool,
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default PartnerBurdenNum;
